import { getDealsArticleConfig } from '../getDealsArticleConfig';
import type { TDealsExperimentGroup } from '../../constants/dealsExperiment';
import type { TDealsContentConfig } from '../../types/dealsContentConfig';

/**
 * Аварийный фичетогл фичи «Сделка» (frontend-content.isDealsBannerExperimentEnabled).
 * Независим от ab-use: выключает фичу целиком, не останавливая эксперимент.
 */
export const isDealsFeatureEnabled = (isEnabled: boolean | undefined): boolean => Boolean(isEnabled);

/**
 * Статья есть в RS dealsContentConfig — у неё есть тексты формы Сделки.
 */
export const isDealsArticle = (postId: number, dealsContentConfig: TDealsContentConfig | null): boolean =>
  Boolean(getDealsArticleConfig(postId, dealsContentConfig));

/**
 * Статья входит в выборку эксперимента: фичетогл включён и статья есть
 * в dealsContentConfig. Группа A/B здесь не учитывается — контрольная
 * группа тоже должна попадать в выборку.
 */
export const isDealsExperimentEligible = (
  isFeatureEnabled: boolean | undefined,
  postId: number,
  dealsContentConfig: TDealsContentConfig | null,
): boolean => isDealsFeatureEnabled(isFeatureEnabled) && isDealsArticle(postId, dealsContentConfig);

/**
 * Показывать баннер и форму Сделки в статье — только тестовая группа B.
 */
export const shouldShowDealsWidgets = (group: TDealsExperimentGroup): boolean => group === 'B';

/**
 * Парсить маркер баннера Сделки и глушить конкурирующие Adfox/журнальные
 * баннеры: фичетогл включён, группа B и у статьи есть тексты баннера.
 */
export const shouldEnableDealsBannerInContent = ({
  isFeatureEnabled,
  isGroupB,
  hasBanner,
}: {
  isFeatureEnabled: boolean | undefined;
  isGroupB: boolean;
  hasBanner: boolean;
}): boolean => isDealsFeatureEnabled(isFeatureEnabled) && isGroupB && hasBanner;
